import { loadStripe, Stripe } from '@stripe/stripe-js';

// Get Stripe publishable key from environment
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

// Initialize Stripe
export const stripePromise: Promise<Stripe | null> = loadStripe(stripePublishableKey);

export const STRIPE_CONFIG = {
  publishableKey: stripePublishableKey,
  apiVersion: '2023-10-16' as const,
};

// Check if Stripe is configured
export const isStripeConfigured = (): boolean => {
  return !!stripePublishableKey && stripePublishableKey.startsWith('pk_');
};


